import React from 'react';
import styled from 'styled-components';
import color from 'color';
import SMTeamLogo from '../SMTeamLogo';

const TblContainer = styled.table`
    border-collapse: separate;
    border-spacing: 0 4px;
    width: 100%;
`;

const TR = styled.tr`
    height: 70px;
    color: ${props => (props.high ? props.theme.content.accentTextColor : props.theme.color)};
    font-weight: ${props => props.theme.fonts.main.bold};

    .rel-badge {
        background-color: ${props =>
            (props.type && color(props.theme.qualRelColors[props.type]).toString()) ||
            color(props.theme.content.backgroundColor)
                .alpha(0.3)
                .rgb()
                .toString()};
        width: 4px;
        display: inline-block;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
    }

    &:nth-child(1) {
        height: 90px;
    }
`;

const TD = styled.td`
    position: relative;
    background: transparent !important;
    width: ${props => (props.fixedWidth ? '70px' : 'auto')};
    justify-content: ${props => (props.fixedWidth ? 'center' : 'left')};
    padding: 0;
    height: 1px;
    color: inherit;
`;

const Col = styled.div`
    display: flex;
    margin: 0 2px;
    align-items: center;
    text-transform: uppercase;
    font-size: 1.75rem;
    line-height: 1;
    height: 100%;
    justify-content: inherit;
    background-color: ${props => (props.high ? props.theme.statTableBgColor : props.theme.content.backgroundColor)};
`;

const Logo = styled.div`
    margin: 0 18px;
`;

const TeamName = styled.div`
    margin-right: 18px;
`;

const Header = () => {
    return null;
};

const Row = ({ row, tournamentId, qualRel, highlight }) => {
    return (
        <TR type={qualRel && row.rankType} high={highlight}>
            <TD fixedWidth>
                {qualRel && <span className="rel-badge" />}
                <Col high={highlight}>{row.rank}</Col>
            </TD>
            <TD>
                <Col high={highlight}>
                    <Logo>
                        <SMTeamLogo tournamentId={tournamentId} teamId={row.teamId} width={50} height={50} />
                    </Logo>
                    <TeamName>{row.teamName}</TeamName>
                </Col>
            </TD>
            <TD fixedWidth>
                <Col high={highlight}>{row.points}</Col>
            </TD>
        </TR>
    );
};

const Container = ({ children }) => (
    <TblContainer>
        <tbody>{children}</tbody>
    </TblContainer>
);
export default { Header, Row, Container };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/tables/SimpleTT.js
 **/